interface CareersProps {
  onContactClick: () => void;
}

export default function Careers({ onContactClick }: CareersProps) {
  return (
    <section id="careers" className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">採用情報</h2>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="text-center mb-6">
            <h3 className="text-lg font-bold text-primary mb-2">
              需要が拡大する電気工事士として<br />活躍したい方を募集しています
            </h3>
            <p className="text-sm text-green-600">基礎からしっかり学べる環境です</p>
          </div>
          <img 
            src="https://public.readdy.ai/ai/img_res/37bd156fa65fa5d56350ec71934a4add.jpg" 
            alt="電気工事技術研修" 
            className="w-full h-48 lg:h-64 object-cover object-top rounded-lg mb-4"
          />
          <div className="bg-gradient-to-r from-primary to-secondary rounded-lg p-4 text-white mb-4">
            <h4 className="font-bold mb-2 text-green-100">充実の研修制度</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center">
                <i className="ri-book-open-line mr-2 text-green-100"></i>
                <span className="text-green-100">基礎から応用まで段階的に指導</span>
              </div>
              <div className="flex items-center">
                <i className="ri-team-line mr-2 text-green-100"></i>
                <span className="text-green-100">先輩職人によるマンツーマン指導</span>
              </div>
              <div className="flex items-center">
                <i className="ri-medal-line mr-2 text-green-100"></i>
                <span className="text-green-100">資格取得を全面バックアップ</span>
              </div>
            </div>
          </div>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-green-600">募集職種</span>
              <span className="text-green-900">電気工事士(未経験歓迎)</span>
            </div>
            <div className="flex justify-between">
              <span className="text-green-600">勤務地</span>
              <span className="text-green-900">愛知県岡崎市周辺</span>
            </div>
            <div className="flex justify-between">
              <span className="text-green-600">勤務時間</span>
              <span className="text-green-900">8:00〜17:00</span>
            </div>
            <div className="flex justify-between">
              <span className="text-green-600">休日</span>
              <span className="text-green-900">担当現場により異なる</span>
            </div>
          </div>
          <div className="mt-4">
            <button 
              onClick={onContactClick}
              className="block w-full bg-secondary text-white py-3 rounded-lg font-medium cursor-pointer text-center whitespace-nowrap hover:bg-green-700 transition-colors"
            >
              <i className="ri-mail-line mr-2 text-green-100"></i>
              <span className="text-green-100">採用についてお問い合わせ</span>
            </button>
          </div>
        </div>
        <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded">
          <p className="text-sm text-green-800">
            <i className="ri-star-line mr-1"></i>
            未経験からでも安心してスタートできます。確かな技術を身につけて、長く活躍できる職人を目指しましょう。
          </p>
        </div>
      </div>
    </section>
  );
}
